module.exports = __webpack_public_path__ + "static/media/cover.0ea36eed.png";